import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthorLayout } from './layouts/AuthorLayout';
import { LearnerLayout } from './layouts/LearnerLayout';
import { AdminLayout } from './pages/admin/AdminLayout';
import { CoursesPage } from './pages/author/CoursesPage';
import { CourseEditorPage } from './pages/author/CourseEditorPage';
import { ContentUploadPage } from './pages/author/ContentUploadPage';
import { LearnerDashboard } from './pages/learner/LearnerDashboard';
import { CoursePlayerPage } from './pages/learner/CoursePlayerPage';
import { AnalyticsPage } from './pages/author/AnalyticsPage';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { UsersPage } from './pages/admin/UsersPage';
import { AdminCoursesPage } from './pages/admin/AdminCoursesPage';

function App() {
  return (
    <Routes>
      {/* Admin Routes */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="courses" element={<AdminCoursesPage />} />
      </Route>

      {/* Author Routes */}
      <Route path="/author" element={<AuthorLayout />}>
        <Route index element={<CoursesPage />} />
        <Route path="upload" element={<ContentUploadPage />} />
        <Route path="courses/:courseId/edit" element={<CourseEditorPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
      </Route>

      {/* Learner Routes */}
      <Route path="/learn" element={<LearnerLayout />}>
        <Route index element={<LearnerDashboard />} />
        <Route path="courses/:courseId" element={<CoursePlayerPage />} />
      </Route>

      {/* Direct Course Access (no layout) */}
      <Route path="/course/:courseId" element={<CoursePlayerPage />} />

      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/learn" replace />} />
    </Routes>
  );
}

export default App;
